import { useSearchParams } from 'react-router-dom';
import { PlayerPreview } from '@/components/preview/PlayerPreview/PlayerPreview';
import { PLAYER_ID } from '@/consts/searchKeys';
import { usePlayerDashboardHref } from '@/hooks/navigation/usePlayerDashboardHref';

export const PlayerDataLockerPlayerPreview = () => {
  const [searchParams] = useSearchParams();
  const dashboardHref = usePlayerDashboardHref(searchParams.get(PLAYER_ID));

  return <PlayerPreview dashboardHref={dashboardHref} />;
};
